import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {dashboardSurfaceAppBuilder} from './config/app-builder'

import {pullsDashboardSurfaceLayoutRoute} from './routes/pulls-dashboard-surface-layout-route'
import {PullsDashboardSurfaceLayoutComponent} from './routes/PullsDashboardSurfaceLayout'
import {pullsDashboardInboxRoute} from './routes/pulls-dashboard-inbox-route'
import {pullsDashboardSurfaceContentRoute} from './routes/pulls-dashboard-surface-content-route'
import {PullsDashboardSurfaceContentComponent} from './routes/PullsDashboardSurfaceContent'
import {PullsDashboardSurfaceLegacyRedirects} from './routes/PullsDashboardSurfaceLegacyRedirects'
import {PullsDashboardIndexGate} from './routes/PullsDashboardIndexGate'
import {PullsDashboardInboxComponent} from './routes/PullsDashboardInbox'
import {createDashboardRouteErrorBoundary} from '@github-ui/shared-dashboard-surface/components/shared/DashboardRouteErrorBoundary'

const PullsDashboardRouteErrorBoundary = createDashboardRouteErrorBoundary({
  reactAppName: 'dashboard-surface',
  resourceName: 'pull requests',
  boundaryName: 'PullsDashboardRoute',
})

export const dashboardSurfaceApp = dashboardSurfaceAppBuilder.createDataRouterAppFromRoutes(() => {
  return [
    pullsDashboardSurfaceLayoutRoute.toRoute({
      Component: PullsDashboardSurfaceLayoutComponent,
      errorBoundary: {override: PullsDashboardRouteErrorBoundary},
      children: [
        {path: 'mentioned', Component: PullsDashboardSurfaceLegacyRedirects},
        {path: 'review-requested', Component: PullsDashboardSurfaceLegacyRedirects},
        {index: true, Component: PullsDashboardIndexGate},
        pullsDashboardSurfaceContentRoute.toRoute({
          Component: PullsDashboardSurfaceContentComponent,
          errorBoundary: {override: PullsDashboardRouteErrorBoundary},
        }),
        pullsDashboardInboxRoute.toRoute({
          Component: PullsDashboardInboxComponent,
          errorBoundary: {override: PullsDashboardRouteErrorBoundary},
        }),
      ],
    }),
  ]
})
registerDataRouterApp(dashboardSurfaceApp)
